import React, { useState } from "react";

// Future talk: one context to handle mapGL and google maps
export type DefaultContext = {
  googleMapRef: google.maps.Map | undefined;
  setGoogleMapRef: React.Dispatch<
    React.SetStateAction<google.maps.Map | undefined>
  >;
};

const GoogleMapContext = React.createContext<DefaultContext>(
  {} as DefaultContext
);

const GoogleMapProvider = ({ children }: { children: React.ReactNode }) => {
  const [googleMapRef, setGoogleMapRef] = useState<google.maps.Map>();

  return (
    <GoogleMapContext.Provider value={{ googleMapRef, setGoogleMapRef }}>
      {children}
    </GoogleMapContext.Provider>
  );
};

export { GoogleMapContext, GoogleMapProvider };
